import { type StepsProps } from 'antd5';
import React from 'react';

import { StyledSteps } from './Steps.style';

/**
 * Optional `itemWidth` property sets the width of each item's content.
 * Must be a valid css width string.
 */
type Props = StepsProps & {
  itemWidth?: string;
};

export const Steps: React.FC<Props> = ({ itemWidth, ...props }) => (
  <StyledSteps $itemWidth={itemWidth} progressDot={true} {...props} />
);
